import { Link } from "react-router-dom";

/**
 * SeoCopy — keyword-rich text block placed at the bottom of thin pages so the
 * page has enough indexable content to rank. Default copy describes the brand
 * and links to related routes (also helps internal link distribution).
 */
export default function SeoCopy({ title, children, links }) {
  return (
    <section className="mt-12 mb-2 rounded-2xl bg-white/60 border-2 border-slate-100 p-5 text-sm text-slate-600" data-testid="seo-copy">
      <h2 className="font-fredoka text-lg font-bold text-slate-800 mb-2">
        {title || "About Bag Dash Kids"}
      </h2>
      <div className="space-y-2 leading-relaxed">
        {children || (
          <>
            <p>
              <strong>Bag Dash Kids</strong> is a youth-led, parent-supervised trash bag
              pickup service operating in Charlotte-area apartment and townhome communities.
              Big Sib Josiah and Lil Sib Jayla cover Friday morning, Friday evening, Saturday
              morning, and Saturday evening pickup windows — the exact days most valet trash
              services take off.
            </p>
            <p>
              Pricing is simple: <strong>$3 for 1 bag, $5 for 2 bags</strong>, with each
              additional bag at $2. Payments run securely through Stripe — we never store
              your card. An optional <strong>$10 monthly bin cleaning</strong> add-on is
              available, and loyal customers earn it free as a Dash Reward.
            </p>
          </>
        )}
      </div>
      {Array.isArray(links) && links.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2 text-xs">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="inline-flex items-center gap-1 text-green-700 font-semibold hover:text-green-900 underline-offset-2 hover:underline"
            >
              {l.label} →
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
